import * as Api from '@ViewModels';
import { useEmailLikeStepState } from './useEmailLikeStepState';

interface UseEmailStepStateProps {
	emailStep: Api.IEmailAutomationStep | null;
	template: Api.IAutomationTemplate | null;
	stepId: string;
	readonly: boolean;
	onSaveError?: (error: Api.IOperationResultNoValue) => void;
}

/**
 * State management hook for EmailStepRenderer.
 * Delegates to the shared useEmailLikeStepState hook.
 */
export function useEmailStepState({ emailStep, template, stepId, readonly, onSaveError }: UseEmailStepStateProps) {
	return useEmailLikeStepState({
		step: emailStep as (Api.IEmailAutomationStep & Api.IHtmlNewsletterAutomationStep) | null,
		template,
		stepId,
		readonly,
		onSaveError,
		hasAdvancedOptions: step => {
			const email = step as Api.IEmailAutomationStep;
			return !!(email.tagToAddOnClick || email.options?.sendToSender);
		},
	});
}
